export const processUrlInCaseFailOverIsRequired = (url: string): string => {
  if (process.env.NODE_ENV !== "production") return url;
  const mainDomains:string[] = [ 'gamingcorpscasino.com', 'cloudfront.net', "amazonaws.com", "localhost:3001" ];
  const currentHost = window.location.hostname;
  const parts = currentHost.split('.');

  const domain =
    parts.length >= 2 ? parts.slice(-2).join('.') : currentHost;

  const isMainDomain = mainDomains.includes(domain);

  if (isMainDomain) {
    return url;
  }

  return url.replace(/gamingcorpscasino\.com/g, domain);
};
